import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

const SuccessfulRegistration = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/login');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-auto p-6">
        <div className="text-center space-y-6">
          <div className="flex justify-center">
            <CheckCircle2 className="h-16 w-16 text-green-500" />
          </div>
          <h1 className="text-2xl font-bold text-foreground">
            {t('auth.emailValidated')}
          </h1>
          <p className="text-muted-foreground">
            {t('auth.emailValidatedDescription')}
          </p>
          <Button 
            onClick={() => navigate('/login')} 
            className="w-full"
          >
            {t('auth.goToLogin')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessfulRegistration;